import { Routes } from '@angular/router';
import { sessionGuard } from 'app/guards/session.guard';

export const quotesAdminRoutes: Routes = [
  {
    canActivate: [sessionGuard],
    data: { key: 'quotes-admin' },
    loadComponent: () => import('./quotes-admin/quotes-admin.page').then((m) => m.QuotesAdminPage),
    path: '',
  },
];
